import { defineMessages } from "react-intl";

export const messages = defineMessages({
  discountCategoriesHeader: {
    id: "AbyDC7",
    defaultMessage: "Eligible Categories",
    description: "section header",
  },
  discountCategoriesButton: {
    id: "g3qjSf",
    defaultMessage: "Assign categories",
    description: "button",
  },
  discountCategoriesTableProductHeader: {
    id: "fV6yX5",
    defaultMessage: "Category Name",
    description: "table head",
  },
  discountCategoriesTableProductNumber: {
    id: "QGjJcT",
    defaultMessage: "Products",
    description: "number of products",
  },
  discountCategoriesNotFound: {
    id: "Uu76vj",
    defaultMessage: "No categories found",
    description: "no categories",
  },
});
